<template>
    <div class="mask" @click="pageClick">
        <!-- 未激活状态 -->
        <div class="claim-view ticket-size" @click.stop="popupCloseHandle">
            <div class="claim-view-textBox">
                <span class="claim-view-textBox-title">
                    Cyberport <br/>
                    Food Coupon
                </span>
                <span class="claim-view-textBox-desc">Enjoy great free food in Cyberport</span>
            </div>
            <div class="claim-view-propBox">
                <span class="claim-view-propBox-label">Redeem with</span>
                <div class="claim-view-propBox-propView">
                    <!-- 道具列表 -->
                    <div class="claim-view-propBox-propView-item" v-for="(item, index) in propList" :key="index">
                        <PropItem 
                            :prop_img="item?.img"
                            :prop_type="item?.prop_type"
                            :prop_number_cur="item?.curNumber"
                            :prop_number_need="item?.needNumber"
                            @click.stop="propClick(item)"
                        />
                    </div>
                </div>
                <div class="button" @click="ClaimHandle">
                    Claim
                </div>
            </div>
        </div>
        <!-- close -->
        <div class="close-view" @click="handleClose">
            <div class="close-view-icon">
                <img class="close-view-icon-left" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
                <span class="close-view-icon-text">Click to close</span>
                <img class="close-view-icon-right" src="@/assets/images/YuliApp/weeklyTask/close_arrow_icon.svg">
            </div>
        </div>
        <!-- 挂载弹窗 -->
        <PropPopup
            v-show="isShowPropPopup"
            :prop="currentProp"
        />
    </div>
</template>

<script>
import { onMounted, ref, getCurrentInstance } from "vue";
import { mapState } from "vuex";
import PropItem from "../PropItem";
import PropPopup from "../PropPopup";
import { postMergeTicket } from "@/api/cyberport.js"
import { ERROR_TEXT } from "@/constants/enums";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
export default {
components: {
    PropItem,
    PropPopup
},
props: {
    propList: {
        type: Object,
        default: () => {
            return {}
        },
    },
},
watch: {
    propList: {
        async handler(value) {
            
        },
        immediate: true,
        deep: true,
    },
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
    }),
},
setup(props, ctx) {
    const { proxy } = getCurrentInstance();
    const currentProp = ref(null);
    const isShowPropPopup = ref(false);
    const useQrCodePng = ref(null);
    onMounted(() => {
        
    });

    /**
     * 票点击处理
     */
    const propClick = (prop) => {
        console.log(prop);
        currentProp.value = prop;
        isShowPropPopup.value = true;
        console.log(isShowPropPopup.value);
    }

    /**
     * 处理关闭
     */
     const handleClose = () => {
      ctx.emit("msgHandle", false);
    };

    const pageClick = () => {
        handleClose();
    }

    const popupCloseHandle = () => {
        isShowPropPopup.value = false;
    }

    /**
     * 检测道具是否合法
     */
    const checkPropNumber = () => {
        let checkFlag = true;
        const propListLocal = props.propList || [];
        if(propListLocal.length == 0)return false;
        for(let i = 0; i < propListLocal.length; i++){
            const item = propListLocal[i];
            if(item.curNumber < item.needNumber){
                checkFlag = false;
                proxy.$toast.show({
                    msg: "No enough props, unable to claim",
                    type: TOAST_TYPE.WARN,
                });
                break;
            }
        }
        return checkFlag;
    }

    const ClaimHandle = async () => {
        if(!checkPropNumber())return;
        proxy.$loading.show();
        try {
            const res = await postMergeTicket();
            const { data } = res;
            if(data.code == 0){
                proxy.$loading.hide();
                proxy.$toast.show({
                    msg: 'Coupon claim success!',
                    type: TOAST_TYPE.SUCCESS,
                });
                ctx.emit("msgHandle", 'reflash');
                handleClose();
            }
        } catch (error) {
            proxy.$loading.hide();
            proxy.$toast.show({
              msg: ERROR_TEXT.NEXTWORK_ERROR,
              type: TOAST_TYPE.ERROR,
            });
        }
    }

    return {
        handleClose,
        propClick,
        popupCloseHandle,
        pageClick,
        ClaimHandle,
        isShowPropPopup,
        currentProp,
        useQrCodePng
    };
},
};
</script>

<style lang="less">
    .mask{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ticket-size{
        width: 320px;
        height: 440px;
        padding: 67px 40px 33px;
        box-sizing: border-box;
    }
    // 未激活
    .claim-view{
        background: url("~@/assets/images/YuliApp/CyberportCoupon/pop_bg_coupon_claim.png")
        no-repeat top left;
        background-size: 100% 100%;
        &-textBox{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: "PingFang SC";
            margin-bottom: 62px;
            &-title{
                color: #4f6942f2;
                font-size: 30px;
                font-weight: 600;
                text-align: center;
                line-height: 36px;
                margin-bottom: 25px;
            }
            &-desc{
                white-space: nowrap;
                color: #677d70;
                font-size: 15px;
                font-weight: 400;
                text-align: left;
            }
        }
        &-propBox{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            font-family: "PingFang SC";
            text-align: center;
            &-label{
                color: #828956;
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 18px;
            }
            &-propView{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-bottom: 18px;
                &-item{
                    margin-right: 16.38px;
                }
                &-item:last-child{
                    margin-right: unset;
                }
            }
        }
    }
    .button{
        width: 128px;
        height: 38px;
        border-radius: 20px;
        border: 1px solid #73572e;
        background: #ffdb5b;
        color: #000000;
        font-size: 16px;
        font-weight: 600;
        font-family: "PingFang SC";
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .close-view{
        position: absolute;
        z-index: 999;
        width: 100%;
        display: flex;
        justify-content: center;
        bottom: 110px;
        img {
            width: 100%;
            height: 100%;
        }
        &-icon{
            width: 125px;
            height: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            &-text{
                width: 83px;
                height: 16px;
                color: #bcc2c7;
                font-size: 13px;
                font-weight: 400;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 15.6px;
            }
            img{
                width: 13px;
                height: 5.91px;
            }
            &-left{
                transform: rotateY(360deg);
            }
            &-right{
                transform: rotateY(180deg);
            }
        }
    }
    #qrcode{
        width: 100%;
        height: 100%;
    }
</style>